module.exports = __webpack_public_path__ + "static/media/27OCHA13.61070005.jpg";